import { Inject, Injectable } from '@angular/core';
import { V1AssetSearchFilterQuery, V1FacetCategory } from '@blk/portfolio-security-server/asset';
import { APP_STORE_CONFIG_TOKEN, NilePaConstants } from '@ddt-web/config';
import { ConfigService, PeConfigKey } from '@ddt-web/config-layer';
import { AppStoreConfig, DataServiceApiConstants, PasRcResolverService } from '@ddt-web/data-service';
import { StringUtil } from '@ddt-web/generic-utils';
import { PasApiService } from '@ddt-web/pas';
import { StoreService } from '@ddt-web/store-service';
import { WweSecuritySearchParams } from '@ddt-web/wealth-web';
import { first, map, switchMap } from 'rxjs/operators';

import { AbstractWorker } from '../models/abstract-worker';

@Injectable()
export class NileAssetTypesLoader extends AbstractWorker {
	constructor(
		private storeService: StoreService,
		private pasApiService: PasApiService,
		private configService: ConfigService,
		@Inject(APP_STORE_CONFIG_TOKEN) public storeConfig: AppStoreConfig,
		private pasRcResolver: PasRcResolverService
	) {
		super();
	}

	public handle(): void {
		if (this.configService.get<boolean>(PeConfigKey.USE_FACETS, false)) {
			const pasSearchQuery = {
				facet: {
					facets: [{ categoryFacet: { fieldName: 'assetType' } }]
				},
				searchQuery: '*'
			} as V1AssetSearchFilterQuery;

			this.pasRcResolver.getRcForUserType(DataServiceApiConstants.SECURITY_DETAILS).pipe(
				map((rc: string) => ({ query: pasSearchQuery, rc })),
				switchMap((requestParams: WweSecuritySearchParams) => this.pasApiService.fetchFacets(requestParams)),
				first(),
				map(results => results[0]['facetCategories']
					.filter(category => category.count && category.label)
					.map((category: V1FacetCategory) => ({
						...category,
						displayName: StringUtil.pluralizeWord(category.label)
					}))),
				map(results => ([{ label: '', displayName: 'All' }, ...results]))
			).subscribe(res => {
				const payload = {
					id: NilePaConstants.ASSET_TYPES,
					children: res
				};
				this.storeService.upsertOne(this.storeConfig.positionDetails, payload);
			});
		}
	}
}
